import { muiThemeOf } from '@cbs-mp/brands-config';
import { ThemeProvider } from '@friendsofreactjs/react-css-themr';
import { StylesProvider } from '@material-ui/core/styles';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import MuiThemeProvider from '@material-ui/styles/ThemeProvider';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import DebugContainer from './containers/DebugContainer';

import NativeAppAwareContainer from './containers/NativeAppAwareContainer';
import SnackbarContainer from './containers/SnackbarContainer';
import { ModalContainer } from './modal';
import { mergeThemes } from './util/mergeThemes';
import { useIdentifyIterate } from './util/useIdentifyIterate';
import { ToastContainer } from './vNext/components/Toast/ToastContainer';
import { ModalProvider } from './vNext/components/Modal/ModalProvider';

const buildAssetsUrl = path => (`${CONFIG.assetsPath}${path}`.replace('//', '/'));

export const createMuiThemeFor = brand => createMuiTheme(muiThemeOf(brand));

const faviconMapping = {
    ab: buildAssetsUrl('/favicon/ab-icon.ico'),
    ap: buildAssetsUrl('/favicon/ap-icon.ico'),
    bt: buildAssetsUrl('/favicon/bt-icon.png'),
    e24: buildAssetsUrl('/favicon/e24-icon.png'),
    godare: buildAssetsUrl('/favicon/godare-icon.png'),
    omni: buildAssetsUrl('/favicon/omni-icon.ico'),
    sa: buildAssetsUrl('/favicon/sa-icon.png'),
    sno: buildAssetsUrl('/favicon/schibsted-icon.ico'),
    sse: buildAssetsUrl('/favicon/schibsted-icon.ico'),
    svd: buildAssetsUrl('/favicon/svd-icon.png'),
    vg: buildAssetsUrl('/favicon/vg-icon.ico'),
    vkno: buildAssetsUrl('/favicon/vkno-icon.ico'),
    wellobe: buildAssetsUrl('/favicon/wellobe-icon.png'),
    wellness: buildAssetsUrl('/favicon/wellness-icon.ico'),
/* PLOP_INJECT_FAVICON */
};

const App = ({ config, routes, localThemes, language }) => {
    useIdentifyIterate();
    const themeId = config?.theme;
    const mergedTheme = mergeThemes(localThemes);

    return (
        <ThemeProvider
            theme={ mergedTheme[themeId] }
        >
            <MuiThemeProvider theme={ createMuiThemeFor(themeId) }>
                <StylesProvider injectFirst>
                    <ModalProvider>
                        <NativeAppAwareContainer>
                            {/* TODO: Discuss providing loader on suspense */}
                            <Suspense fallback={ null }>
                                <Helmet
                                    title={ config.title }
                                    link={ [
                                        { rel: 'shortcut icon', href: faviconMapping[themeId] },
                                    ] }
                                    bodyAttributes={{
                                        lang: language,
                                    }}
                                />
                                { routes }
                                <DebugContainer />
                                <ModalContainer />
                                <SnackbarContainer />
                                <ToastContainer />
                            </Suspense>
                        </NativeAppAwareContainer>
                    </ModalProvider>
                </StylesProvider>
            </MuiThemeProvider>
        </ThemeProvider>
    );
};

App.propTypes = {
    config: PropTypes.shape({
        theme: PropTypes.string,
        publication: PropTypes.string,
        title: PropTypes.string,
    }).isRequired,
    routes: PropTypes.node.isRequired,
    localThemes: PropTypes.shape({}).isRequired,
    language: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    config: state.config,
    styling: state.styling,
});

export default connect(mapStateToProps)(App);
